<template>
  <div class="travel-view">
    <div class="travel-container">
      <v-header v-if="displayHeader"></v-header>
      <router-view :key="$route.fullPath"></router-view>
      <v-go-top></v-go-top>
      <v-footer></v-footer>
    </div>
  </div>
</template>
<script>
import Header from './layouts/Header'
import Footer from './layouts/Footer'

export default {
  components: {
    VHeader: Header,
    VFooter: Footer
  },
  mounted: function () {
    window.scrollTo(0, 0)
  },
  computed: {
    displayHeader: function () {
      if (this.$route.fullPath.indexOf('main') > -1 ||
      this.$route.fullPath.indexOf('tour') > -1) {
        return true
      }
      return !this.app
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 991px) {
  .travel-container {
    left: 0;
    width: 100%;
    position: relative;
    background: #fff;
    transition: left 0.3s ease;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue